import { ControlsLike } from "./types";

export interface ControlsOptions {
  /** Where to listen. Defaults to `document`. */
  target?: EventTarget;
  /** Start responding to keys immediately. Defaults to true. */
  enabled?: boolean;
}

export class Controls implements ControlsLike {
  left = false;
  right = false;
  fire = false;

  private enabled: boolean;
  private readonly target: EventTarget;
  private readonly onKeyDown: EventListener;
  private readonly onKeyUp: EventListener;

  constructor(options: ControlsOptions = {}) {
    this.target = options.target ?? document;
    this.enabled = options.enabled ?? true;
    this.onKeyDown = (e) => this.setKey(e as KeyboardEvent, true);
    this.onKeyUp = (e) => this.setKey(e as KeyboardEvent, false);
    this.target.addEventListener("keydown", this.onKeyDown);
    this.target.addEventListener("keyup", this.onKeyUp);
  }

  /**
   * While disabled the listeners stay attached but set nothing and, crucially,
   * never call preventDefault — so arrow keys and space keep scrolling the page.
   */
  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
    if (!enabled) {
      this.left = false;
      this.right = false;
      this.fire = false;
    }
  }

  private setKey(e: KeyboardEvent, pressed: boolean): void {
    if (!this.enabled) return;
    switch (e.key) {
      case "ArrowLeft":
      case "a":
      case "A":
        this.left = pressed;
        break;
      case "ArrowRight":
      case "d":
      case "D":
        this.right = pressed;
        break;
      case " ":
      case "ArrowUp":
        this.fire = pressed;
        if (pressed) e.preventDefault();
        break;
    }
  }

  destroy(): void {
    this.target.removeEventListener("keydown", this.onKeyDown);
    this.target.removeEventListener("keyup", this.onKeyUp);
  }
}
